import React, { FC } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';

interface Props {
  socialMedia?: any;
  copyright?: any;
}

const FooterBottom: FC<Props> = ({ copyright }) => {
  const { formatMessage } = useFormat({ name: 'common' });

  return (
    <>
      <div className="hidden items-center justify-between md:flex md:pt-32 lg:pt-0 xl:pt-0 2xl:pt-0">
        <Typography className="custom-text-css text-16 font-medium text-white md:text-15 2xl:text-16">
          {copyright?.children?.[0]?.children?.[0]?.text}
        </Typography>{' '}
      </div>
      <div className="mt-32 flex flex-col items-start md:hidden 2xl:pt-48">
        <Typography className="text-500 pb-10 text-15 font-medium text-[#FFFFFF] md:text-14 2xl:mt-20">
          {copyright?.children?.[0]?.children?.[0]?.text}
        </Typography>
      </div>
    </>
  );
};

export default FooterBottom;
